import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=52561c38&scoped=true"
import script from "./NotificationBadge.vue?vue&type=script&lang=ts"
export * from "./NotificationBadge.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=52561c38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52561c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52561c38')) {
      api.createRecord('52561c38', component.options)
    } else {
      api.reload('52561c38', component.options)
    }
    module.hot.accept("./NotificationBadge.vue?vue&type=template&id=52561c38&scoped=true", function () {
      api.rerender('52561c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Notifications/NotificationBadge.vue"
export default component.exports